export default __webpack_public_path__ + "static/media/sponsors.cce00aab.png";